import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';


import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';



import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { first } from 'rxjs';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { OfferLetterPreviewComponent } from 'src/app/hradmin/ELCM/offer-letter-preview/offer-letter-preview.component';
import { OfferletterviewComponent } from 'src/app/hradmin/ELCM/elcm/offerletterview/offerletterview.component';
import { MsiViewComponent } from '../msi-view/msi-view.component';
import * as saveAs from 'file-saver';

@Component({
  selector: 'app-mis-attachment-view',
  templateUrl: './mis-attachment-view.component.html',
  styleUrls: ['./mis-attachment-view.component.scss'],
})
export class MisAttachmentViewComponent  implements OnInit {

 yearList: any[] = [];
  selectedYear: any;
  buttonColorName: any;
  loggedInUserCompanyID: any;
 
  loggedInUserRole: any;



  dropdownSettings: IDropdownSettings = {};
  selectedDepartment: any;
  selectedBand: any;
  selectedManager: any;
  selectedEmployee: any;
  selectedRating: any;
  managerId: any;
  employeeId: any;
  searchOfferTableData: any;
  loggedInCompanyFiscalyear: any;
  getIncrementInputYear: any[] = [];
  companyYears: any[] = [];
  getDepartmentsList: any[] = [];
  getBandList: any[] = [];
  getManagerList: any[] = [];
  getEmployeeList: any[] = [];
  getSelectedRating: any[] = [];
  getRatingData: any[] = [];
  isShowDownloadBtn: boolean = false;
  selectAllChecked: boolean = false;
msiAttached:any;
fileName:any=[]
  incrementLetterData: any[] = [];
  candidateId: any;
  candidateData: any;
  commmanArray:any=[]
  constructor(private route: Router, private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public dialog: MatDialog, public sharedService: SharedService,
    private http: HttpClient, @Inject(MAT_DIALOG_DATA) public fileData: any, public mobileResponsiveService: MobileResponsiveService) {


   this.msiAttached =fileData.msiAttached;
    console.log(fileData.fileName);
   this.fileName=fileData?.filename.split(',');



this.commmanArray = this.msiAttached.map((url:any, index:any) => ({
  msi: url,
  file: this.fileName[index],
  isChecked: false
}));

   
    // this.candidateData = fileData?.candidateID;
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserRole = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }


    this.getpmsyearlist();

  }
  pmsYears: any = []
formatDate(dateString: string): string {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  };

  const formattedDate = `${day}/${month}/${year}`;
  const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

  return `Date: ${formattedDate}\nTime: ${formattedTime}`;
}




  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }
  allSelectedData: any = []
  toggleSelectAll() {
    this.commmanArray.forEach((item: any) => item.isChecked = this.selectAllChecked);

    this.allSelectedData = this.commmanArray
    this.isShowDownloadBtn = this.selectAllChecked; // Show download if all are selected

  }
  lettterDataForSingleSelection: any = []
  checkedEmployees: any = []
  onCheckboxChange(event: MatCheckboxChange, filedata: any) {
    if (event.checked) {
      // Add employee to the checked list if checked
      this.checkedEmployees.push(filedata);
    } else {
      // Remove employee from checked list if unchecked
      this.checkedEmployees = this.checkedEmployees.filter((elm: any) => elm.file !== filedata.file);
    }

    // Update appointment letter data to show only checked employees
    this.lettterDataForSingleSelection = [...this.checkedEmployees];
    const allChecked = this.commmanArray.every((item: any) => item.isChecked);
    const anyChecked = this.commmanArray.some((item: any) => item.isChecked);


    this.selectAllChecked = allChecked; // Update 'Select All' state
    this.isShowDownloadBtn = anyChecked; // Show download button if at least one is checked
  }
  downloadSelected() {
  const selectedIds = this?.commmanArray
    ?.filter((data: any) => data.isChecked)
    .map((data: any) => data.candidateId);

  if (!selectedIds || selectedIds.length === 0) {
    console.warn("No items selected for download.");
    return;
  }

  // Case 1: All selected
  if (this.selectAllChecked) {
    this.allSelectedData = this.lettterDataForSingleSelection.length > 0
      ? this.lettterDataForSingleSelection
      : this.allSelectedData;

    this.allSelectedData.forEach((elm: any) => {
      if (elm.msi && elm.file) {
        saveAs(elm.msi, elm.file);
      }
    });
  } 
  // Case 2: Partial selected
  else {
    if (!this.lettterDataForSingleSelection) {
      console.error("Download data is not defined.");
      return;
    }

    this.lettterDataForSingleSelection.forEach((elm: any) => {
      if (elm.msi && elm.file) {
        saveAs(elm.msi, elm.file);
      }
    });
  }
}



  viewDocument(fileUrl: string): void {

    if (fileUrl) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${this.loggedInUserCompanyID}/${fileUrl}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }

  onClickPreviewLetter(fileName: any, userId: any, msi: any) {
    // console.log(msi);
    
    // const dialogConfig = new MatDialogConfig();
    // // dialogConfig.height = '70%';
    // // dialogConfig.width = '100%';
    // dialogConfig.maxWidth= this.mobileResponsiveService.modelMaxWidthForMobileDevice;
    // dialogConfig.data = {
    //   fileName: fileName,
    //   msi: msi// Pass the full data here
    // };
    // dialogConfig.panelClass = 'phi_mdc_dialog__container_100';
    // const dialogRef = this.dialog.open(MsiViewComponent, dialogConfig);
    // dialogRef.afterClosed().subscribe(result => { });
console.log(fileName,msi);

    saveAs(msi,fileName);
  }



  filteredEmployees: any = [];
  employees: any = [];

  curretcommmanArray: any = [];






}
